/* 3D képkeret: főoldali látványelem (<kk3d-hero>) és termékoldali gombok + felugró ablak (<kk3d-product>).
 * A 3D motor (kk-keret-3d.js) csak láthatóvá váláskor vagy gombnyomásra töltődik be. */
(() => {
  if (window.KK3D) return;
  const coarse = matchMedia('(pointer: coarse)').matches;
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const engines = new Map();
  const engine = url => { if (!engines.has(url)) engines.set(url, import(url).catch(e => { engines.delete(url); throw e; })); return engines.get(url); };
  const texOf = el => ({ oak: el.dataset.texOak, birch: el.dataset.texBirch, black: el.dataset.texBlack, brown: el.dataset.texBrown });
  const logoOf = el => ({ light: el.dataset.logoLight, dark: el.dataset.logoDark });
  const press = (root, attr, val) => root.querySelectorAll(`[data-${attr}]`).forEach(b => b.setAttribute('aria-pressed', String(b.dataset[attr] === String(val))));

  /* Variáns opciók -> modell kulcsok. Csak a modellezett keretes variánsoknál van 3D (nyomat, digitális: nincs).
     Az arany és az ezüst a vékony fémhatású keretcsaládba tartozik, a motor ehhez saját méreteket használ. */
  const COLOR_RULES = [[/fehér/i, 'white'], [/fekete/i, 'black'], [/nyír/i, 'birch'], [/tölgy/i, 'oak'], [/arany/i, 'gold'], [/ezüst/i, 'silver']];
  const SIZE_KEYS = { '13x18':1, '21x30':1, '30x40':1 };
  function parseVariant(opts){
    if (!opts) return { ok:false };
    let color = null, size = null, orient = null;
    for (const raw of opts){
      const v = String(raw || '');
      if (!color && /képkeret/i.test(v)) for (const [re, key] of COLOR_RULES) if (re.test(v)){ color = key; break; }
      const m = [...v.matchAll(/(\d{2})\s*[x×]\s*(\d{2})/gi)].pop();
      if (m){ const a = +m[1], b = +m[2], k = `${Math.min(a, b)}x${Math.max(a, b)}`; if (SIZE_KEYS[k]){ size = k; orient = a > b ? 'landscape' : 'portrait'; } }
    }
    return { ok: !!(color && size), color, size, orient };
  }

  /* ---------- főoldal ---------- */
  class Keret3DHero extends HTMLElement {
    connectedCallback(){
      if (this._init) return; this._init = true;
      this.stage = this.hasAttribute('data-kk3d-stage') ? this : this.querySelector('[data-kk3d-stage]');
      this.loadBtn = this.querySelector('[data-kk3d-load]');
      this.tapBtn = this.querySelector('[data-kk3d-tap]');
      this.querySelectorAll('[data-view]').forEach(b => b.addEventListener('click', () => { if (!this.ctl) return; press(this, 'view', b.dataset.view); this.ctl.goView(b.dataset.view); this.syncSpin(); }));
      this.querySelector('[data-kk3d-spin]')?.addEventListener('click', () => { if (!this.ctl) return; this.ctl.setSpin(!this.ctl.isSpinning()); this.syncSpin(); });
      this.querySelector('[data-kk3d-ar]')?.addEventListener('click', () => this.ctl && this.ctl.openAR());
      this.loadBtn?.addEventListener('click', () => this.mount());
      this.tapBtn?.addEventListener('click', () => this.activate(true));
      const manual = this.dataset.load === 'click' || saveData;
      if (manual){ if (this.loadBtn) this.loadBtn.hidden = false; return; }
      this.io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)){ this.io.disconnect(); this.mount(); } }, { rootMargin:'300px' });
      this.io.observe(this);
    }
    syncSpin(){ const b = this.querySelector('[data-kk3d-spin]'); if (b && this.ctl) b.setAttribute('aria-pressed', String(this.ctl.isSpinning())); }
    activate(on){
      if (!this.ctl) return;
      this.ctl.setInteractive(on);
      if (this.tapBtn) this.tapBtn.hidden = on;
    }
    async mount(){
      if (this.ctl || this.mounting) return; this.mounting = true;
      if (this.loadBtn) this.loadBtn.hidden = true;
      this.classList.add('is-loading');
      try {
        const { mountKeret3D } = await engine(this.dataset.module);
        const d = this.dataset, tapToRotate = coarse;
        this.ctl = await mountKeret3D(this.stage, {
          size: d.size, color: d.color, orient: d.orient, mode: d.mode, view: d.view,
          autoRotate: d.autorotate === 'true', rotateSpeed: parseFloat(d.speed) || 1, image: d.image || null,
          textures: texOf(this), logos: logoOf(this), zoom: false, interactive: !tapToRotate,
          onInteract: () => this.querySelectorAll('[data-view]').forEach(b => b.setAttribute('aria-pressed', 'false')),
          onError: e => console.warn('[KK 3D]', e.message),
        });
        if (tapToRotate && this.tapBtn){
          this.tapBtn.hidden = false;
          new IntersectionObserver(es => { if (!es[0].isIntersecting) this.activate(false); }, { threshold:0 }).observe(this);
        }
        this.classList.add('is-ready');
        this.syncSpin();
        const arB = this.querySelector('[data-kk3d-ar]');
        if (arB) arB.hidden = !(coarse || this.dataset.arDesktop === 'true');
      } catch (e){
        console.warn('[KK 3D] A 3D nézet nem töltődött be:', e);
        this.classList.add('is-failed');
      } finally { this.classList.remove('is-loading'); this.mounting = false; }
    }
    disconnectedCallback(){ this.io?.disconnect(); this.ctl?.destroy(); this.ctl = null; this._init = false; }
  }

  /* ---------- termékoldal ---------- */
  class Keret3DProduct extends HTMLElement {
    connectedCallback(){
      if (this._init) return; this._init = true;
      try { this.cfg = JSON.parse(this.querySelector('script[data-kk3d-config]').textContent); } catch { this.cfg = { variants:{}, graphics:{} }; }
      this.tib = this.cfg.tib || /[?&]kk3d_tib=1\b/.test(location.search);
      this.dlg = this.querySelector('dialog.kk3d-modal');
      document.body.appendChild(this.dlg);           // a téma oszlopainak transform/overflow beállításai ne zavarják
      this.stage = this.dlg.querySelector('[data-kk3d-stage]');
      this.chip = this.dlg.querySelector('[data-kk3d-chip]');
      this.btns = this.querySelector('[data-kk3d-btns]');
      this.querySelector('[data-kk3d-open]')?.addEventListener('click', () => this.open(false));
      // további belépési pontok bárhol az oldalon (pl. a cím alatti chip)
      this.triggers = [...document.querySelectorAll('[data-kk3d-trigger]')];
      this.triggers.forEach(t => {
        t.addEventListener('click', () => this.open(false));
        if (!this.tib) t.querySelectorAll('.kk3d-chip__sep, .kk3d-chip__sub').forEach(x => x.remove());
      });
      const arBtn = this.querySelector('[data-kk3d-ar]');
      if (arBtn){ arBtn.hidden = !(coarse || this.cfg.arDesktop); arBtn.addEventListener('click', () => this.open(true)); }
      this.dlg.querySelector('[data-kk3d-close]').addEventListener('click', () => this.dlg.close());
      this.dlg.addEventListener('click', e => { if (e.target === this.dlg) this.dlg.close(); });
      this.dlg.addEventListener('close', () => { this.ctl?.setSpin(false); document.documentElement.classList.remove('kk3d-lock'); });
      this.dlg.querySelectorAll('[data-view]').forEach(b => b.addEventListener('click', () => { if (!this.ctl) return; press(this.dlg, 'view', b.dataset.view); this.ctl.goView(b.dataset.view); this.syncSpin(); }));
      this.dlg.querySelector('[data-kk3d-spin]')?.addEventListener('click', () => { if (!this.ctl) return; this.ctl.setSpin(!this.ctl.isSpinning()); this.syncSpin(); });
      const ar2 = this.dlg.querySelector('[data-kk3d-ar2]');
      if (ar2){ ar2.hidden = !(coarse || this.cfg.arDesktop); ar2.addEventListener('click', () => this.ctl && this.ctl.openAR()); }
      // variánsváltás: Minimog esemény, az űrlap id mezője, és tartalékként a cím ?variant= paramétere
      this.onVar = () => this.refresh();
      document.addEventListener('variant:changed', this.onVar);
      document.addEventListener('change', this.onChange = e => { if (e.target && (e.target.name === 'id' || e.target.closest?.('variant-picker, .tee-field, [class*="teeinblue"]'))) setTimeout(this.onVar, 60); }, true);
      this.timer = setInterval(() => { this.placeTee(); if (!document.hidden) this.refresh(); }, 800);
      this.refresh();
      this.placeTee();
    }
    disconnectedCallback(){
      document.removeEventListener('variant:changed', this.onVar); document.removeEventListener('change', this.onChange, true);
      clearInterval(this.timer); this.ctl?.destroy(); this.ctl = null; this.dlg?.remove(); this.slotEl?.remove(); this._init = false;
    }
    /* A gombsort a Teeinblue „Előnézet” gombja alá tesszük. A Teeinblue később renderel és újrarajzolhat, ezért ellenőrizzük. */
    placeTee(){
      if (this.cfg.teeSlot === false || !this.btns) return;
      const prev = document.querySelector('.tee-btn--preview');
      const action = prev && prev.closest('.tee-form-action');
      if (!action || !action.parentNode){
        if (this.slotEl && !this.slotEl.isConnected){ this.appendChild(this.btns); this.classList.remove('is-relocated'); this.slotEl = null; }
        return;
      }
      if (this.slotEl && this.slotEl.isConnected && this.slotEl.previousElementSibling === action) return;
      if (!this.slotEl){ this.slotEl = document.createElement('div'); this.slotEl.className = 'kk3d kk3d-tee-slot'; }
      action.after(this.slotEl);
      this.slotEl.appendChild(this.btns);
      this.slotEl.hidden = !this.v;
      this.classList.add('is-relocated');
    }
    currentVariantId(){
      // a Teeinblue saját variánsválasztója csak a cím ?variant= paraméterét frissíti, az űrlap id mezőjét nem, ezért az az elsődleges
      const fromUrl = new URLSearchParams(location.search).get('variant');
      const inp = document.querySelector('product-info form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      return String(fromUrl || (inp && inp.value) || this.cfg.selected || '');
    }
    refresh(){
      const id = this.currentVariantId();
      if (id === this.lastId) return;
      this.lastId = id;
      const v = parseVariant(this.cfg.variants[id]);
      this.v = v.ok ? v : null;
      this.hidden = !v.ok;
      if (this.slotEl) this.slotEl.hidden = !v.ok;
      this.triggers?.forEach(t => { t.hidden = !v.ok; });
      if (v.ok && this.ctl && this.dlg.open) this.apply();   // zárt ablaknál a következő megnyitáskor frissül
    }
    pickGraphic(){
      const g = this.cfg.graphics || {}, o = this.v ? this.v.orient : 'portrait';
      return g[o] || g[o === 'portrait' ? 'landscape' : 'portrait'] || g.fallback || null;
    }
    async graphicSource(){
      if (this.tib){
        try {
          const { captureTeeinblue } = await engine(this.dataset.module); const c = await captureTeeinblue();
          // a Teeinblue előnézete mindig a vásárló aktuális állapotát mutatja; "saját" akkor, ha már szerkesztett rétegeket
          let own = true;
          try { const cur = window.teeinblue && window.teeinblue.getCurrentCustomization && window.teeinblue.getCurrentCustomization();
                own = !!(cur && Object.keys(cur).some(k => k.startsWith('layer-'))); } catch {}
          if (c) return { image:c, own };
        }
        catch (e){ console.warn('[KK 3D] Teeinblue előnézet nem olvasható:', e); }
      }
      return { image: this.pickGraphic(), own:false };
    }
    async apply(){
      if (!this.ctl || !this.v) return;
      const src = await this.graphicSource();
      const key = (src.image && typeof src.image !== 'string') ? 'tib:' + Date.now() : String(src.image);   // a Teeinblue-ból olvasott kép mindig friss
      const p = { size:this.v.size, color:this.v.color, mode: this.v.size === '30x40' ? 'wall' : 'table',
                  orient: src.image ? 'auto' : this.v.orient };   // valódi grafikánál a grafika aránya adja a tájolást
      if (key !== this.imgKey){ p.image = src.image; this.imgKey = key; }
      const st = await this.ctl.set(p);
      this.setChip(src.own, st && st.isSample);
    }
    setChip(own, sample){
      if (!this.chip) return;
      this.chip.textContent = own ? (this.cfg.ownLabel || 'A te terved alapján') : (this.cfg.sampleLabel || 'Minta grafikával');
      this.chip.classList.toggle('is-own', !!own);
      const n = this.dlg.querySelector('[data-kk3d-note]');
      if (n) n.textContent = own ? (this.cfg.ownNote || '') : (this.cfg.sampleNote || n.textContent);
      if (n) n.hidden = !n.textContent;
    }
    syncSpin(){ const b = this.dlg.querySelector('[data-kk3d-spin]'); if (b && this.ctl) b.setAttribute('aria-pressed', String(this.ctl.isSpinning())); }
    async open(ar){
      this.refresh(); if (!this.v) return;
      if (typeof this.dlg.showModal === 'function') this.dlg.showModal(); else this.dlg.setAttribute('open', '');
      document.documentElement.classList.add('kk3d-lock');
      if (!this.ctl){
        this.dlg.classList.add('is-loading');
        try {
          const { mountKeret3D } = await engine(this.dataset.module);
          const src = await this.graphicSource();
          this.imgKey = (src.image && typeof src.image !== 'string') ? 'tib:' + Date.now() : String(src.image);
          this.ctl = await mountKeret3D(this.stage, {
            size:this.v.size, color:this.v.color, orient: src.image ? 'auto' : this.v.orient, mode: this.v.size === '30x40' ? 'wall' : 'table',
            view:'threeq', autoRotate:true, rotateSpeed:1.2, image:src.image, textures:texOf(this), logos:logoOf(this), zoom:true, interactive:true,
            onInteract: () => { this.dlg.querySelectorAll('[data-view]').forEach(b => b.setAttribute('aria-pressed', 'false')); this.syncSpin(); },
            onError: e => console.warn('[KK 3D]', e.message),
          });
          this.setChip(src.own, this.ctl.state().isSample);
          this.dlg.classList.add('is-ready');
        } catch (e){
          console.warn('[KK 3D] A 3D nézet nem töltődött be:', e);
          this.dlg.classList.add('is-failed');
          return;
        } finally { this.dlg.classList.remove('is-loading'); }
      } else {
        this.dlg.classList.add('is-loading');
        try { await this.apply(); } finally { this.dlg.classList.remove('is-loading'); }
        this.ctl.goView('threeq');   // méretváltás után a kamera távolsága is igazodjon
        this.ctl.setSpin(true);
      }
      press(this.dlg, 'view', 'threeq'); this.syncSpin();
      if (ar) this.ctl.openAR();
    }
  }

  customElements.define('kk3d-hero', Keret3DHero);
  customElements.define('kk3d-product', Keret3DProduct);
  window.KK3D = { parseVariant };
})();
